export function notZeroDays() {

    return {
        require: 'ngModel',
        restrict: 'A',
        link: (scope, element, attr, ngModelCtrl) => {

            function validateZero() {

                return parseInt(ngModelCtrl.$viewValue) > 0 || !ngModelCtrl.$viewValue;
            }

            ngModelCtrl.$validators.nonzeroDays = validateZero;
        }
    };
}



// WEBPACK FOOTER //
// ./src/ui/directives/not-zero-days.directive.js